import React from 'react';
import { useTranslation } from 'react-i18next';
import { Database, Construction } from 'lucide-react';

export default function StoragePage() {
  const { t } = useTranslation();

  return (
    <div className="p-4 sm:p-6 max-w-xl mx-auto">
      <div className="flex flex-col items-center text-center py-12 px-4">
        <div className="w-16 h-16 rounded-2xl bg-primary-100 dark:bg-primary-900/40 flex items-center justify-center mb-6">
          <Database className="h-8 w-8 text-primary-600 dark:text-primary-400" />
        </div>
        <h1 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
          {t('storage.comingSoonTitle')}
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-md">
          {t('storage.comingSoonDescription')}
        </p>
        <div className="inline-flex items-center gap-2 rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-200 px-4 py-2 text-sm font-medium">
          <Construction className="h-4 w-4" />
          {t('storage.workInProgress')}
        </div>
      </div>
    </div>
  );
}
